module.exports = __webpack_public_path__ + "images/liinilaevad/ms-icon-70x70.png";